import { ROUTES } from "@/routes";
import { primaryColor } from "@/theme";
import { List, ListItemText, Paper, Box, IconButton, ListItemIcon } from "@mui/material";
import { Link } from "react-router-dom";
import ListItemButtonSelected from "./ListItemButtonSelected";
import HasPermissionWrapper from "./HasPermissionWrapper";
import SidebarIcon from "./SidebarIcon";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';

export const SidebarAdminButtons = ({ isCollapsed }: { isCollapsed?: boolean }) => {
  return (
    <>
      <ListItemButtonSelected component={Link} to={ROUTES.ADMIN_DASHBOARD} isCollapsed={isCollapsed}>
        <ListItemIcon>
          <SidebarIcon component={DashboardOutlinedIcon} />
        </ListItemIcon>
        <ListItemText primary="Přehled" />
      </ListItemButtonSelected>

      <HasPermissionWrapper permission="clients">
        <ListItemButtonSelected component={Link} to={ROUTES.ADMIN_CLIENTS} isCollapsed={isCollapsed}>
          <ListItemIcon>
            <SidebarIcon component={BusinessOutlinedIcon} />
          </ListItemIcon>
          <ListItemText primary="Klienti" />
        </ListItemButtonSelected>
      </HasPermissionWrapper>

      <HasPermissionWrapper permission="admins">
        <ListItemButtonSelected component={Link} to={ROUTES.ADMIN_ADMINS} isCollapsed={isCollapsed}>
          <ListItemIcon>
            <SidebarIcon component={AdminPanelSettingsOutlinedIcon} />
          </ListItemIcon>
          <ListItemText primary="Administrátoři" />
        </ListItemButtonSelected>
      </HasPermissionWrapper>

      <HasPermissionWrapper permission="faqs">
        <ListItemButtonSelected
          component={Link}
          to={ROUTES.ADMIN_FREQUENTLY_ASKED_QUESTIONS}
          isCollapsed={isCollapsed}
        >
          <ListItemIcon>
            <SidebarIcon component={QuizOutlinedIcon} />
          </ListItemIcon>
          <ListItemText primary="Často kladené dotazy" />
        </ListItemButtonSelected>
      </HasPermissionWrapper>

      <HasPermissionWrapper permission="deleted-items">
        <ListItemButtonSelected component={Link} to={ROUTES.ADMIN_DELETED_ITEMS} isCollapsed={isCollapsed}>
          <ListItemIcon>
            <SidebarIcon component={DeleteSweepOutlinedIcon} />
          </ListItemIcon>
          <ListItemText primary="Smazané položky" />
        </ListItemButtonSelected>
      </HasPermissionWrapper>
    </>
  );
};

interface SidebarAdminProps {
  isCollapsed?: boolean;
  onToggle?: () => void;
}

const SidebarAdmin = ({ isCollapsed, onToggle }: SidebarAdminProps) => {
  return (
    <Box sx={{
      width: isCollapsed ? 64 : 240,
      flexShrink: 0,
      transition: 'width 0.3s ease',
      position: 'relative',
      // Stay above isolated page content and below the fixed topbar on scroll.
      zIndex: (theme) => theme.zIndex.appBar - 1,
    }}>
      <Paper
        sx={{
          width: isCollapsed ? 64 : 240,
          boxSizing: "border-box",
          height: "100%",
          borderRightColor: "transparent",
          boxShadow: isCollapsed ? `4px 0px 12px rgba(0,0,0,0.15)` : `4px -3px 3px -3px ${primaryColor}`,
          paddingTop: "10px",
          overflowX: "hidden",
          whiteSpace: "nowrap",
          transition: 'width 0.3s ease, box-shadow 0.3s ease',
          '&:hover': isCollapsed ? {
            width: 240,
            boxShadow: `8px 0px 24px rgba(0,0,0,0.15)`,
          } : {},
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', px: 1, mb: 1 }}>
          <IconButton onClick={onToggle} size="small" sx={{ color: 'text.secondary' }}>
            {isCollapsed ? <KeyboardDoubleArrowRightIcon /> : <KeyboardDoubleArrowLeftIcon />}
          </IconButton>
        </Box>
        <List>
          <SidebarAdminButtons isCollapsed={isCollapsed} />
        </List>
      </Paper>
    </Box>
  );
};

export default SidebarAdmin;
